export default {
  'ja': {
    'user_list': {
      'employee': '社員',
      'retiree': '退職者',
      'onboarding': '入社手続き',
      'label': {
        'user_no': 'ID',
        'user_name': '社員名',
        'shop_name': '店舗名',
        'age': '年齢',
        'user_type': '役職',
        'joined_date': '入社日',
        'change_date': '役職異動日',
        'overed_date': '退職日'
      }
    },
    'shop_list': {
      'responsible_person': '店舗',
      'label': {
        'shop_name': '店舗名',
        'address': '住所',
        'tel': '電話番号'
      }
    },
    'user_change_list': {
      'change': '役職異動日',
      'label': {
        'user_no': 'ID',
        'user_name': '社員名',
        'shop_name': '店舗名',
        'age': '年齢',
        'user_type': '役職',
        'change_date': '役職異動日'
      }
    },
    'user_photo_list': {
      'photo': '写真'
    },
    'rejectreason_list': {
      'label': {
        'id': 'ID',
        'reject_reason': '却下理由',
        'reject_reason_default_content': '初期表示却下コメント',
        'reject_reason_priority': '表示優先度'
      }
    },
    'usertype': {
      'list': {
        'Name': '役職名',
        'Default': '権限',
        'Priority': '表示優先度',
        'Employee': '社員区分'
      },
      'type1': 'システム管理者',
      'type2': '店舗管理者以上',
      'type3': '自店入力者',
      'type4': '自店閲覧者',
      'type5': '人事管理責任者',
      'employee': 'ACCESS連携',
      'not_employee': 'ACCESS連携外'
    },
    'turnover_class': {
      'class1': '自己都合',
      'class2': '契約満了',
      'class3': '定年退職',
      'class4': '解雇',
      'class5': '死亡',
      'class6': 'その他'
    },
    'domain': {
      'list': {
        'No': 'ドメインNo',
        'Name': 'ドメイン名',
        'Content': 'ドメイン内容'
      }
    },
    'businesstype': {
      'list': {
        'Work': '役職名',
        'Detail': '業務内容'
      }
    },
    'turnover': {
      'list': {
        'Group': '離職区分',
        'Content': '離職事由'
      }
    },
    'join': {
      'list': {
        'Class': '入社経緯'
      }
    },
    'unit': {
      'minute': '分',
      'hour': '時間',
      'day': '日'
    },
    'login': {
      'forgot_password': 'パスワードをリセットする'
    },
    'forgot_password': {
      'input_email': '自分のメールアドレスをご入力してください。',
      'send_reset_email': 'パスワードをリセットするためのリンクが含まれているメールが入力したメールアドレスへ送信されます。',
      'back_to_login': 'すでにアカウントを持っていますか？',
      'completed': 'パスワードリセット用メールをお客様のメールアドレスへ届けました。メールからリンクをクリックして、パスワードをリセットしてください。'
    },
    'reset_password': {
      'input_new_password': '新しいパスワードを入力してください。',
      'reset_cancel': {
        'message1': 'パスワード変更を取消し',
        'message2': 'します。'
      },
      'completed': 'パスワードが変更されました。'
    },
    'shop_manager_list': {
      'label': {
        'shop_name': '店舗名',
        'shop_manager_name': '店舗管理者'
      }
    },
    'shop_manager_edit': {
      'label': {
        'name': '社員名',
        'age': '年齢',
        'user_type': '役職',
        'join_date': '入社日'
      }
    },
    'shift_creator_list': {
      'label': {
        'shop_name': '店舗名',
        'shift_creator_name': 'シフト作成者'
      }
    },
    'shift_creator_edit': {
      'label': {
        'name': '社員名',
        'age': '年齢',
        'user_type': '役職',
        'join_date': '入社日'
      }
    },
    'supplier': {
      'label': {
        'name': 'サプライヤー名',
        'name_hurigana': 'サプライヤー名ふりがな',
        'responsible_name': '担当者名',
        'tel_no': 'TEL',
        'fax_no': 'FAX',
        'mail': 'メールアドレス',
        'postal_code': '郵便番号',
        'address': '住所',
        'order_method': '出力方法'
      }
    },
    'consumableItem': {
      'label': {
        'name': '消耗品名',
        'kana': 'ふりがな',
        'code': '型番',
        'category': 'カテゴリー',
        'supplier': 'サプライヤー',
        'price': '単価',
        'lot price': '1ロットあたりの単価',
        '1 per': '1個あたり',
        '1 lot per': '1ロットあたり',
        'quantity': 'の数量',
        'unit': '単位',
        'order reception': '発注受付',
        'size': 'サイズ規格',
        'just stock number': '必要在庫数',
        'stock quantity': '現在在庫数',
        'order quantity': '発注数'
      }
    },
    'category': {
      'label': {
        'name': 'カテゴリー名',
        'name_hurigana': 'カテゴリー名ふりがな'
      }
    },
    'holdPlace': {
      'label': {
        'name': '保管場所名',
        'shop_name': '店舗名'
      }
    },
    'shopConsumableItem': {
      'label': {
        'consumable_item_name': '消耗品名',
        'shop_name': '店舗名',
        'just_stock_number': '必要在庫数'
      }
    },
    'shopOrder': {
      'label': {
        'date': '店舗依頼日',
        'name': '店舗名',
        'status': 'ステータス',
        'order responsible': '発注担当者名',
        'change state': '変更状態',
        'year month week': '年月 週数'
      }
    },
    'tanomail': {
      'label': {
        'shop_name': '店舗名',
        'represent_code': '代表コード(タイラ企業コード)',
        'group_code': 'グループコード(店舗コード)',
        'login_id': 'ログインID',
        'password': 'パスワード',
        'management_number': '貴社管理番号',
        'receive_responsible': '受取担当者名'
      }
    },
    'Yes': 'はい',
    'No': 'いいえ',
    'Home': 'ホーム',
    'User Shop': '社員・店舗',
    'User': '社員',
    'User List': '社員一覧',
    'User Photo List': '写真一覧',
    'User Detail': '社員詳細',
    'User New': '社員新規登録',
    'User Edit': '社員編集',
    'User Over': '離職登録',
    'User History': '履歴確認',
    'User Pdf': '書類保存',
    'Shop History': '店舗異動',
    'Shop History Force Edit': '店舗履歴編集',
    'Usertype History': '役職異動',
    'Usertype History Force Edit': '役職履歴編集',
    'Retiree List': '退職者一覧',
    'User Change List': '役職異動日一覧',
    'Master Manage': 'マスタ管理',
    'ACCESS': 'ACCESS連携',
    'Message': 'メッセージ確認',
    'Moral': 'モラル確認',
    'Moral List': '登録一覧',
    'Moral Detail': 'モラル確認詳細',
    'Moral New': 'モラル確認新規',
    'Moral Edit': 'モラル確認編集',
    'Moral Result List': '回答確認',
    'Shop Manager': '店舗管理者',
    'Shop Manager List': '店舗管理者一覧',
    'Shop Manager Edit': '店舗管理者編集',
    'Shop Manager Clear': '管理者クリア',
    'Human Staff': '人事担当者',
    'Human Staff List': '人事担当者一覧',
    'Human Staff Edit': '人事担当者編集',
    'Shift Creator': 'シフト作成者',
    'Shift Creator List': 'シフト作成者一覧',
    'Shift Creator Edit': 'シフト作成者編集',
    'Shift Creator Clear': 'シフト作成者クリア',
    'Magazine': '社内報',
    'Magazine List': '社内報一覧',
    'Magazine New': '社内報新規',
    'Magazine Edit': '社内報編集',
    'ShiftManage': 'シフト管理',
    'ShiftAttendance': '出勤簿印刷',
    'ShiftCreate': 'シフト作成',
    'ShiftClass': '固定シフト登録',
    'ShiftCondition': '勤務条件登録',
    'ShiftConditionEdit': '勤務条件編集',
    'Propose': '提案制度',
    'Propose Unapproved List': '承認前一覧',
    'Propose Approved List': '採用前一覧',
    'Propose Result': '集計',
    'Propose Title': '課題提案',
    'Propose Title Detail': '課題詳細',
    'Propose Title Create': '課題登録',
    'Propose Title Edit': '課題編集',
    'Propose Unapproved Detail': '承認前詳細',
    'Propose Approved Detail': '採用前詳細',
    'User Type': '役職',
    'User Type List': '役職一覧',
    'User Type New': '役職新規登録',
    'User Type Detail': '役職詳細',
    'User Type Edit': '役職編集',
    'Domain Type': 'ドメイン',
    'Domain Type List': 'ドメイン一覧',
    'Domain Type New': 'ドメイン新規登録',
    'Domain Type Detail': 'ドメイン詳細',
    'Domain Type Edit': 'ドメイン編集',
    'Turnover Type': '離職事由',
    'Turnover Type List': '離職事由一覧',
    'Turnover Type New': '離職事由新規登録',
    'Turnover Type Detail': '離職事由詳細',
    'Turnover Type Edit': '離職事由編集',
    'Business Type': '業務内容',
    'Business Type List': '業務内容一覧',
    'Business Type New': '業務内容新規登録',
    'Business Type Detail': '業務内容詳細',
    'Business Type Edit': '業務内容編集',
    'Join Type': '入社経緯',
    'Join Type List': '入社経緯一覧',
    'Join Type New': '入社経緯新規登録',
    'Join Type Detail': '入社経緯詳細',
    'Join Type Edit': '入社経緯編集',
    'Shop': '店舗',
    'Shop List': '店舗一覧',
    'Shop New': '店舗新規登録',
    'Shop Detail': '店舗詳細',
    'Shop Edit': '店舗編集',
    'Reject Reason': '却下理由',
    'Reject Reason List': '却下理由一覧',
    'Reject Reason New': '却下理由新規登録',
    'Reject Reason Detail': '却下理由詳細',
    'Reject Reason Edit': '却下理由編集',
    'Guideline': 'モラル行動指針',
    'Guideline List': 'モラル行動指針一覧',
    'Guideline New': 'モラル行動指針新規登録',
    'Guideline Detail': 'モラル行動指針詳細',
    'Guideline Edit': 'モラル行動指針編集',
    'Questions': '360°評価',
    'Questions List': '360°評価一覧',
    'Questions New': '360°評価新規',
    'Questions Detail': '360°評価詳細',
    'Questions Edit': '360°評価編集',
    'Step Up': '360°多面評価',
    'Step Up List': 'ステップアップ者登録一覧',
    'Step Up Detail': 'ステップアップ者登録詳細',
    'Step Up New': 'ステップアップ者登録新規',
    'Step Up Edit': 'ステップアップ者登録編集',
    'Step Up Result List': '研修評価回答確認',
    'Normal Questions': '常態評価',
    'Normal Questions List': '常態評価一覧',
    'Normal Questions New': '常態評価新規',
    'Normal Questions Detail': '常態評価詳細',
    'Normal Questions Edit': '常態評価編集',
    'Ability Questions': '能力評価',
    'Ability Questions List': '能力評価一覧',
    'Ability Questions New': '能力評価新規',
    'Ability Questions Detail': '能力評価詳細',
    'Ability Questions Edit': '能力評価編集',
    'Evaluate Questions': '人事評価',
    'Evaluate Questions New': '評価対象登録新規',
    'Evaluate Questions List': '人事評価登録一覧',
    'Evaluate Questions Result List': '人事評価回答確認',
    'Evaluate Questions Detail': '人事評価詳細',
    'Evaluate Questions Edit': '人事評価編集',
    'Master Service Questions': '接客評価マスタ',
    'Master Service Questions New': '接客評価マスタ登録',
    'Master Service Questions Detail': '接客評価マスタ詳細',
    'Master Service Questions List': '接客評価マスタ一覧',
    'Master Service Questions Edit': '接客評価マスタ編集',
    'Service Questions': '接客評価',
    'Service Questions New': '接客評価対象登録新規',
    'Service Questions List': '接客評価登録一覧',
    'Service Questions Result List': '接客評価回答確認',
    'Service Questions Result Detail': '接客評価回答詳細',
    'Service Questions Detail': '接客評価詳細',
    'Service Questions Edit': '接客評価編集',
    'Machine Order Shop': '遊技台発注店舗管理',
    'Es Mycard': 'ESmyカード',
    'Company Notice': '全社通達',
    'Company Notice List': '全社通達登録一覧',
    'Company Notice Detail': '全社通達詳細',
    'Company Notice Edit': '全社通達編集',
    'Company Notice New': '全社通達登録',
    'Company Notice Result': '全社通達集計',
    'Stock': '在庫管理',
    'Comfirm Order': '発注依頼確認',
    'Comfirm Order Detail': '発注依頼詳細',
    'Order History': '発注履歴',
    'Order History Store List': '発注履歴店舗一覧',
    'Order History Store Detail': '発注履歴店舗詳細',
    'Master Stock': '在庫管理マスタ',
    'Stock Analysis': '在庫分析',
    'Master Supplier': 'サプライヤー',
    'Master Supplier New': 'サプライヤー新規登録',
    'Master Supplier Edit': 'サプライヤー編集',
    'Master Consumable Item': '消耗品',
    'Master Consumable Item List': '消耗品一覧',
    'Master Consumable Item New': '消耗品新規登録',
    'Master Consumable Item Edit': '消耗品編集',
    'Confirm Shop Stock Consumable Item Count': '店舗の必要在庫数を確認',
    'Shop Stock Consumable Item Count List': '店舗の必要在庫数一覧',
    'Shop Stock Consumable Item Count Edit': '店舗の必要在庫数登録',
    'Master Category': 'カテゴリー',
    'Master Category New': 'カテゴリー新規登録',
    'Master Category Edit': 'カテゴリー編集',
    'Master Tanomail': 'たのめーるアカウント',
    'Master Tanomail List': 'たのめーるアカウント一覧',
    'Master Tanomail New': 'たのめーるアカウント新規登録',
    'Master Tanomail Edit': 'たのめーるアカウント編集',
    'Consumable Item Info': '消耗品情報',
    'My Profile': 'マイページ',
    'Safety Confirmation': '安否確認',
    'Safety Confirmation List': '安否確認一覧',
    'Safety Confirmation Answer List': '安否確認報告一覧',
    'Safety Confirmation New': '安否確認登録',
    'Safety Confirmation Edit': '安否確認編集',
    'Safety Confirmation Save': '安否確認を登録し公開',
    'Safety Confirmation Update': '安否確認を更新',
    'Safety Confirmation Close': '公開を終了する',
    'Confrim Closing Safety Confirmation': '安否確認の公開を終了して良いですか？',
    'Deadline Notice': 'お知らせ',
    'Onboarding List': '入社手続き 対象者一覧',
    'Onboarding New': '新入社員 仮登録',
    'Onboarding Detail': '入社手続き 確認',
    'onboarding': {
      'label': {
        'user_name': '氏名',
        'user_name_furigana': 'ふりがな',
        'shift_classes': '配属店舗のシフト区分',
        'profile': '本人情報',
        'email': 'メールアドレス',
        'shop_name': '配属店舗',
        'user_type': '役職',
        'employment_pattern': '雇用パターン',
        'join_day': '入社日',
        'status': 'ステータス',
        'documents': '提出書類',
        'submitted': '提出済',
        'not_submitted': '未提出',
        'approved': '承認',
        'rejected': '差戻し',
        'invitation': '招待URL',
        'invitation_valid': '有効',
        'invitation_expired': '期限切れ',
        'my_number': 'マイナンバー',
        'contract': '労働条件通知書',
        'contract_period_to': '契約終了日',
        'consented_at': '承諾日時',
        'review_comment': 'コメント',
        'submission_no_suffix': '回目',
        'submission_unit': '件',
        'file_unit': '枚',
        'past_submissions': '過去の提出',
        'expiry_date': '有効期限',
        'not_applicable': 'なし（本人申告）',
        'join_class': '入社経緯',
        'registration': '本登録',
        'check_ok': 'OK',
        'progress': '進捗',
        'register_ready': '本登録可',
        'optional': '後から入力可',
        'optional_note': '本登録の必須ではありません'
      },
      'employment_pattern': {
        'full_time': 'アテンダント（有期）',
        'part_free': 'パート（フリー）',
        'part_80': 'パート（80）',
        'clerk': '店舗事務員',
        'attendant': 'アテンダント（一般）'
      },
      'button': {
        'register': '仮登録して招待メールを送る',
        'detail': '確認',
        'approve': '承認',
        'reject': '差戻し',
        'approve_submission': 'この書類を承認する',
        'reject_submission': 'この書類を差し戻す',
        'resend': '招待メール再送',
        'create_contract': '労働条件通知書を作成',
        'show_my_number': 'マイナンバーを表示',
        'edit_profile': '本人情報を訂正する',
        'save_profile': '訂正を保存する',
        'save_shift_classes': 'シフト区分を保存する',
        'complete_registration': '本登録する',
        'force_complete_registration': '不足があっても本登録する（強制登録）',
        'cancel': 'キャンセル',
        'back': '一覧へ戻る'
      },
      'profile': {
        'user_name': '姓',
        'user_firstname': '名',
        'user_name_furigana': 'ふりがな（せい）',
        'user_firstname_furigana': 'ふりがな（めい）',
        'user_birthday': '生年月日',
        'user_sex': '性別',
        'user_post_no': '郵便番号',
        'user_address': '住所',
        'user_mobile': '携帯電話番号',
        'join_class': '入社経緯',
        'emergency_contact_name': '緊急連絡先1（氏名）',
        'emergency_contact_relation': '緊急連絡先1（続柄）',
        'emergency_contact_tel': '緊急連絡先1（電話番号）',
        'emergency_contact2_name': '緊急連絡先2（氏名）',
        'emergency_contact2_relation': '緊急連絡先2（続柄）',
        'emergency_contact2_tel': '緊急連絡先2（電話番号）',
        'bank_name': '銀行名',
        'bank_branch_name': '支店名',
        'bank_account_type': '口座種別',
        'bank_account_holder': '口座名義',
        'bank_account_number': '口座番号',
        'sex_male': '男性',
        'sex_female': '女性',
        'account_ordinary': '普通',
        'account_current': '当座',
        // 通勤手段・配偶者・扶養・兼業・職歴・備考（r643 / r665-682。総務用名簿に印字する）
        'commute_method': '通勤手段',
        'commute_public_detail': '公共機関の内容',
        'is_dormitory': '入寮',
        'has_spouse': '配偶者の有無',
        'has_dependents': '扶養義務の有無',
        'dependents_count': '扶養人数',
        'has_side_job': '兼業の有無',
        'side_job_started_on': '他社就職年月（YYYY-MM）',
        'work_history1_from': '職歴1 開始年月（YYYY-MM）',
        'work_history1_to': '職歴1 終了年月（YYYY-MM）',
        'work_history1_content': '職歴1 内容',
        'work_history2_from': '職歴2 開始年月（YYYY-MM）',
        'work_history2_to': '職歴2 終了年月（YYYY-MM）',
        'work_history2_content': '職歴2 内容',
        'work_history3_from': '職歴3 開始年月（YYYY-MM）',
        'work_history3_to': '職歴3 終了年月（YYYY-MM）',
        'work_history3_content': '職歴3 内容',
        'profile_remarks': '備考（本人入力）',
        'profile_confirmed_at_format': '本人の確認（相違なし）日時',
        'commute_car': '車',
        'commute_motorbike': 'バイク',
        'commute_bicycle': '自転車',
        'commute_walk': '徒歩',
        'commute_public_transport': '公共機関',
        'yes': '有',
        'no': '無'
      },
      'message': {
        'forbidden': 'この画面を表示する権限がありません。',
        'required': '氏名・メールアドレス（ドメインを含む）・配属店舗・役職を入力してください。',
        'shop_fixed': '配属店舗は自店に固定されます。',
        'shift_classes_required': 'パートの場合は配属店舗のシフト区分を1つ以上選択してください。',
        'shift_classes_help': '選んだ区分の始業・終業・休憩を労働条件通知書の勤務欄に印字します（複数選択可）。',
        'no_shift_classes': '配属店舗にシフト区分が登録されていません。通知書の勤務欄は空欄で作成されます。',
        'shift_classes_recreate': 'シフト区分を変えたら保存してから「労働条件通知書を作成」で作り直してください。',
        'profile_help': '本人が入力した内容です。添付の住民票などで確認し、必要なら訂正してから本登録してください。本登録すると、この内容がそのまま社員一覧・社員詳細に反映されます。通勤手段・配偶者・扶養義務・兼業・職歴・備考は総務用名簿印刷に印字されます（本登録の必須ではありません）。',
        'month_format': '年月は YYYY-MM（例 2020-04）で入力してください。',
        'registration_help': '書類の承認とは別に、最後に【本登録する】を押すと入社手続きが完了し、社員一覧・シフトに載ります（本人と本社採用担当に完了メールを送ります）。必須の項目がすべて OK になると押せます。本人の入社手続き画面にも同じ判定の進捗（本人向けの文言）が表示されます。',
        'optional_documents_help': '運転免許証・任意保険証・自動車検査証記録事項は本登録の必須ではありません（マイナンバーまでの書類が承認されていれば本登録できます）。未提出のまま本登録した場合は、本登録後に「お知らせ」（有効期限）と本人の「書類の更新」画面から提出・期限日の登録ができます。',
        'registration_not_ready': '不足している項目があるため、まだ本登録できません。',
        'force_registration_help': '不足している項目がありますが、人事管理責任者・システム管理者は強制的に本登録できます。',
        'registration_confirm': 'この社員を本登録して入社手続きを完了にします。よろしいですか？',
        'force_registration_confirm': '不足している項目がありますが、強制的に本登録して入社手続きを完了にします。よろしいですか？',
        'register_help': '仮登録すると、本人宛に入社手続きの招待メール（有効期限14日）を送信します。',
        'clerk_help': '事務員を選ぶと、ユーザ種別は事務員（350）になり、契約期間は入社日から1年間になります。',
        'clerk_user_type_fixed': '雇用パターンが店舗事務員のため、役職は店舗事務員（350）に固定されます。',
        'approve_confirm': 'この書類を承認します。よろしいですか？',
        'reject_confirm': 'この書類を差し戻します。本人へメールで通知されます。よろしいですか？',
        'comment_required': '差戻しコメントを入力してください。',
        'no_documents': 'まだ書類が提出されていません。',
        'no_contract': '労働条件通知書はまだ作成されていません。',
        'not_consented': '本人の承諾待ちです。',
        'my_number_hidden': 'マイナンバーは人事管理責任者のみ閲覧できます。',
        'my_number_confirm': 'マイナンバーを表示します。閲覧操作は記録されます。よろしいですか？',
        'my_number_logged': 'この閲覧操作は監査ログに記録されました。'
      }
    },
    'shift_io': {
      'label': {
        'title': 'Excel 取込',
        'file': '取込ファイル',
        'preview_result': '取込内容の確認',
        'applied': '変更されるセル',
        'cleared': 'うち 未設定に戻す',
        'cleared_row': '（未設定に戻す）',
        'unchanged': '変更なし',
        'error_rows': 'エラー',
        'login_id': '社員番号',
        'user_name': '社員名',
        'shift_date': '日付',
        'shift_class': '区分',
        'time': '時間',
        'break_time': '休憩(分)'
      },
      'button': {
        'preview': '取込内容を確認',
        'apply': 'この内容で取り込む',
        'close': '閉じる'
      },
      'message': {
        'import_help': 'この画面の「ダウンロード」で出力した Excel（xlsx）を編集して選択してください。セルはプルダウンの値（公休・有休 などの区分名、または 09:00-17:30 のような登録済みの時刻）だけ受け付けます。空欄のセルはシフトを未設定に戻します。シフト表に行が無い社員は取込時に行を作ります。エラーが1つでもあると取り込みません。',
        'created_users': 'シフト表に行が無いため、取込時に {count} 名分の行を作成します。',
        'apply_confirm': '確認した内容でシフトを更新します。空欄のセルは未設定に戻ります。よろしいですか？',
        'fix_errors': 'エラーがあるため取り込めません。エラーを直してから、もう一度ファイルを選択してください。',
        'unsaved_warning': 'シフト表に保存していない変更があります。取込を実行するとその変更は失われます。',
        'applied': '取り込みました。画面のシフトを再読込しました。',
        'counter_manual_input': '早番・遅番カウンターは、直接入力してください'
      }
    },
    'Payroll': '給与・賞与明細',
    'Payroll Excluded': '給与・賞与明細の対象外',
    'payroll': {
      'label': {
        'document_type': '種別',
        'file': 'Excelファイル',
        'login_id': '社員番号',
        'user_name': '社員名',
        'pay_date': '支給日',
        'result': '取込結果',
        'imported': '新規',
        'updated': '更新',
        'skipped': '対象外のためスキップ',
        'error_rows': 'エラー行',
        'pdf_failed': 'PDF生成に失敗',
        'import_panel': 'Excelから取り込む',
        'format': '取込ファイルの形式',
        'sample': 'サンプルExcelをダウンロード'
      },
      'format': {
        'sheet': '1行目が列名、2行目以降が1行＝1社員。1枚目のシートを読み込みます。',
        'required': '必須の列は「社員番号」だけです。支給日はこの画面で指定します（ファイルに支給日の列は不要）。',
        'login_id': '社員番号は社員一覧の社員番号です。先頭のゼロ（例 001214）は付いていても構いません。',
        'columns': '列名がそのまま明細の項目名になります。列を足せばその名前で表示されます。',
        'upsert': '同じ社員番号・支給日・種別を再取込すると上書きされます。',
        'excluded': '役員等（対象外に設定した社員）は読み飛ばし、件数を表示します。'
      },
      'document_type': {
        'all': 'すべて',
        'salary': '給与明細',
        'bonus': '賞与明細'
      },
      'button': {
        'import': '取り込む',
        'importing': '取込中...',
        'show': '内容を見る',
        'download': 'PDFをダウンロード',
        'open_import': '取込を開く',
        'close_import': '取込を閉じる'
      },
      'message': {
        'forbidden': 'この画面を表示する権限がありません。',
        'file_help': 'xlsx ファイルを選択してください。給与ソフトから出力したファイルをそのまま使えます。',
        'pay_date_required': '支給日を入力してください。',
        'excluded_help': '役員等で紙の明細を運用する社員は「対象外」にすると、取込時にスキップされ従業員画面にも表示されません。',
        'excluded_confirm': '給与・賞与明細の対象設定を変更します。よろしいですか？',
        'pdf_not_ready': 'PDFがまだ生成されていません'
      }
    },
    'Document Renewal': '書類更新の確認',
    'Document Renewal List': '書類更新 提出一覧',
    'Document Renewal Detail': '書類更新の確認',
    'deadline_notice': {
      // 期限日が未登録（入社手続きで提出せずに本登録した免許証・任意保険証・車検証）のお知らせ
      'date_unregistered': '未登録（書類の提出待ち）'
    },
    'document_renewal': {
      'submitted_badge': '提出あり',
      'label': {
        'user_name': '社員名',
        'shop_name': '店舗名',
        'document_type': '書類種別',
        'status': '状況',
        'submitted_at': '提出日時',
        'file_name': 'ファイル名',
        'current_deadline': '現在の期限日',
        'new_deadline': '新しい期限日',
        'review_comment': '差戻しコメント',
        'reviewed_at': '確認日'
      },
      'status': {
        'all': 'すべて（取り下げを除く）',
        'submitted': '提出済',
        'confirmed': '確認済',
        'rejected': '差戻し',
        'superseded': '取り下げ'
      },
      'button': {
        'confirm': '確認して期限日を保存',
        'reject': '差戻し（コメント）',
        'back': '一覧へ戻る'
      },
      'message': {
        'forbidden': 'この画面を表示する権限がありません。',
        'confirm_alert': '期限日を保存し、提出された書類を現行の書類として登録します。よろしいですか？',
        'reject_alert': '差戻しますか？本人へメールで通知されます。',
        'date_required': '新しい期限日を入力してください。',
        'comment_required': '差戻しコメントを入力してください。'
      }
    },
    'Login': 'ログイン',
    'Logout': 'ログアウト',
    'Read More': 'さらに読み込む',
    'Read All': 'すべて見る',
    'Close': '閉じる',
    'age': '{age}歳',
    'New Registration': '新規登録',
    'Print': '名簿一覧印刷',
    'My Shop Print': '自店名簿一覧印刷',
    'Csv Download': 'データ出力',
    'Pdf Download': 'PDF出力',
    'Back': '戻る',
    'Show': '表示',
    'Edit': '編集',
    'Show Edit': '詳細・編集',
    'Save': '保存',
    'Delete': '削除',
    'Register': '登録',
    'Cancel': 'キャンセル',
    'Detail': '詳細',
    'Login ID': 'ID',
    'Password': 'パスワード',
    'Need to login': 'ログインしてください。',
    'No Data': 'データがありません。',
    'Delete Confirm': '削除すると元に戻すことはできません。\n本当に削除しますか？',
    'Retire Cancel Confirm': '退職を本当に取り消しますか？',
    'Approve Confirm': '提案が承認されます。\nWONDER WORLDに表示されます。',
    'Not Approve Confirm': '提案投稿者へ差し戻しされます。',
    'Adopt Confirm': '提案が採用されます。\nWONDER WORLDに表示されます。',
    'Update Successful': '正常に更新されました。',
    'Notice Confirm': 'このお知らせを削除しますか？',
    'Avatar Upload Successful': '写真をアップロードしました。',
    'Mail Address': 'メールアドレス',
    'Current Password': '現在のパスワード',
    'New Password': '新しいパスワード',
    'New Password Retyped': '新しいパスワード(確認)',
    'Password Reset': 'パスワードリセット',
    'Reset': 'リセット',
    'Send': '送信',
    'Image Upload Message': 'ここにファイルをドロップしてください',
    'Image Upload Successful': 'ファイルをアップロードしました。',
    'Image Upload Error': '失敗：画像ファイルを貼り付けてください',
    'validations': {
      'required': '必須項目です。',
      'password_rule': '4文字以上10文字以下の英数字を入力してください。',
      'password_confirmation': '同じパスワードを入力してください。',
      'invalid_furigana': 'ひらがなを入力してください。',
      'invalid_number': '半角数字で入力してください。',
      'not_hyphen': '「-」なしで入力してください',
      'fomat_tel': '電話番号形式で入力してください',
      'fomat_fax': 'FAX番号形式で入力してください',
      'before_today': '本日以前を入力して下さい。',
      'after_release': '2018年1月4日以降を入力して下さい。',
      'after_today': '明日以降を入力して下さい。',
      'integrity': '抽出開始日＞抽出終了日になっています。',
      'check': '一つ以上選択してください。',
      'same_selected_value': '同一選択肢名が存在します。',
      'date_range': '翌月までしか入力できません。'
    },
    'Will Must': 'MUST・WILL',
    'Referral': '友達紹介',
    'ReferralList': '友達紹介一覧',
    'Maintenance': 'メンテナンス中です。しばらくお待ちください。',
    'user': {
      'remove_success_message': '名簿を削除しました。'
    },
    'Confirmed Message': '確認した'
  }
}



// WEBPACK FOOTER //
// ./src/i18n.js